<script lang="js">
export default {
  name: "Todo",
  props: {
    todos: {
      type: Array,
      required: true,
      default: () => []
    }, loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    validTodos() {
      return this.todos.filter(todo => todo && todo.type);
    }
  },
};
</script>

<template>
  <div class="card border-0 shadow-sm py-3">
    <div class="card-body overflow-auto" style="max-height: 400px">
      <!-- Loading state -->
      <div v-if="loading" class="text-center text-muted small">
        <div class="spinner-border text-secondary mb-2" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p>Loading todos...</p>
      </div>

      <!-- Empty state -->
      <div v-if="todos.length < 1" class="text-center text-muted small py-4">
        <p class="mb-0">
          <i class="bi bi-card-list fs-4 d-block mb-2 text-secondary"></i> No
          todos available.
        </p>
      </div>

      <!-- Render todos -->
      <div
        v-else
        v-for="(todo, index) in validTodos"
        :key="index"
        class="bg-body-secondary text-muted rounded p-2 mb-2 d-flex"
      >
        <i class="bi bi-circle me-2 small"></i>
        <div class="d-flex flex-column small">
          <span class="fw-bold">{{ todo.title || "No title" }}</span>
          <span
            >{{ todo.message || "No todo" }}
            <RouterLink
              v-if="todo.destination"
              :to="{ name: todo.destination }"
            >
              Click here
            </RouterLink>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped></style>
